var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "item",
      class: { hasSubitems: _vm.hasSubitems },
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
        mouseover: _vm.mouseOver,
        mouseleave: function ($event) {
          return _vm.timeoutHide()
        },
      },
    },
    [
      _vm._v(_vm._s(_vm.item.title)),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasSubitems && this.visibleSubitems,
              expression: "hasSubitems && this.visibleSubitems",
            },
          ],
          staticClass: "subitems",
        },
        _vm._l(_vm.item.subitems, function (subitem) {
          return _c("Item", {
            key: subitem.title,
            attrs: {
              item: subitem,
              args: _vm.args,
              delay: _vm.delay,
              menuHovered: _vm.menuHovered,
            },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }